// Nombres de presentación: no cambia IDs ni nombres guardados en snapshots.
export function nombreZonaEnPlano(zona){
 const mesa=String(zona?.id||'').match(/^2P-MESA([1-4])$/i);
 return mesa?'MESA '+mesa[1]:String(zona?.label||zona?.name||'');
}
export function pisoZonaNombre(zona){
 const floor=zona?.floorId||zona?.objeto3d?.floorId;
 if(floor==='2P'||zona?.piso==='2P'||(!floor&&String(zona?.id||zona?.zonaId||'').startsWith('2P-')))return '2do piso';
 if(floor==='1P'||zona?.piso==='1P')return 'Planta baja';
 return zona?.piso||'Planta baja';
}
